export default "__VITE_ASSET__BSZjX36v__"